module.exports = __webpack_public_path__ + "img/s00173.ae3c02b1.png";